import React from 'react';
import { useNavigate } from "react-router-dom";
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button} from '@material-ui/core';
import { LoadingButton } from '@mui/lab';
import SaveIcon from '@mui/icons-material/Save';
import InputAdornment from '@mui/material/InputAdornment';
import SavedSearchIcon from '@mui/icons-material/SavedSearch';
import {Select, MenuItem, InputLabel, FormControl } from '@mui/material';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
// import DateTimePicker from '@mui/lab/DateTimePicker';
// import AdapterDateFns from '@mui/lab/AdapterDateFns';
// import LocalizationProvider from '@mui/lab/LocalizationProvider';

import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import TextField from '@mui/material/TextField';
import {getVisibility} from '../commonfun/common';
import AgentSelect from '../agents/AgentSelect';
import TagsOptions from '../components/TagsNoOption';
//import moment from 'moment';
import axios from 'axios';
///import Autocomplete from './Autocomplete';
import {API_URL} from '../utils/EnvVars';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});


var vertical='top',horizontal='center';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => { 
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false); 
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  const [saveLoading, setSaveLoading] = React.useState(false);
  
  const childRefUser = React.useRef();
  
  const [accessType, setAccessType] = React.useState(1);
  const [accessWithType, setAccessWithType] = React.useState("");
  const [accessWithNames, setAccessWithNames] = React.useState("");
  const [accessWithIds, setAccessWithIds] = React.useState("");

  const [accountName, setAccountName] = React.useState("");
  const [category, setCategory] = React.useState("noselect");
  const [company, setCompany] = React.useState("");
  const [website, setWebsite] = React.useState("");
  const [gstNumber, setGstNumber] = React.useState("");
  const [panNumber, setPanNumber] = React.useState("");
  const [aadhaarNumber, setAadhaarNumber] = React.useState("");
  const [cin, setCin] = React.useState("");
  const [consigneeCode, setConsigneeCode] = React.useState("");
  const [products, setProducts] = React.useState("");
  const [industry, setIndustry] = React.useState("");
  const [rank, setRank] = React.useState("");
  const [tags, setTags] = React.useState([]);
  const [purchasePotential, setPurchasePotential] = React.useState(0);
  const [creditDays, setCreditDays] = React.useState(0);
  const [companyType, setCompanyType] = React.useState("");
  const [registrationYear, setRegistrationYear] = React.useState("");
  const [turnover, setTurnover] = React.useState("");

  const [ownerId, setOwnerId] = React.useState(0);
  const [ownerAlias, setOwnerAlias] = React.useState("");

  const [categoryList, setCategoryList] = React.useState([]);

  const [contactName, setContactName] = React.useState("");
  const [mobile, setMobile] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [address, setAddress] = React.useState("");
  const [city, setCity] = React.useState("");
  const [state, setState] = React.useState("");
  const [country, setCountry] = React.useState("");
  const [pinCode, setPinCode] = React.useState("");

  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {    
    setOpen(false);
  };

  function hideAlert(){
		setShowAlert(false);
	}

  React.useEffect(() => {	

      setAccountName("");
      setCategory("noselect");
      setCompany("");
      setWebsite("");
      setGstNumber("");
      setPanNumber("");
      setAadhaarNumber("");
      setCin("");
      setConsigneeCode("");
      setProducts("");
      setIndustry("");
      setRank("");
      setCompanyType("");
      setRegistrationYear("");
      setTurnover("");
      if(props.userObj){
        setOwnerAlias(props.userObj.fullName);
        setOwnerId(props.userObj.userId);
      }
      setAccessWithType("");
      setAccessWithNames("");
      setAccessWithIds("");
      
      setContactName("");
      setMobile("");
      setEmail("");
      setPhone("");
      setAddress("");
      setCity("");
      setState("");
      setPinCode("");
      setCountry("");

      setPurchasePotential(0);
      setCreditDays(0);
      setTags([]);

      if(open){
        setAccessType(getVisibility(props.userObj.visibilityJson,'Accounts'));
      }

    if(open){
      getApiDataCategory();
    }

	}, [props.userObj,open]);
  
  async function getApiDataCategory(){ 
      let apiUrl=API_URL+'/crm-account-category-cache';
      let axiosHeader = {
          'Content-Type': 'multipart/mixed',
          'device': 'web',
          'registerId': props.userObj.registerId,
          'uid': props.userObj.loginId,
          'fullName': props.userObj.fullName,
          'token': props.userObj.token,
      };
      const config = {
        method: 'get',
        url: apiUrl,
        headers: axiosHeader
      }
      await axios(config)
        .then(response => {
        if(response && response.data && response.data.responseTxt==="success"){  
          setCategoryList(response.data.list);
        }else if(response && response.data && response.data.responseTxt==="invalidtoken"){
          navigate('/invalidtoken');
        }
      }).catch((error) => {
          setSeverityAlert("error");
          setShowAlert(true);
          setAlertMessage(""+error);			
          return false;
        })	
  }


	function saveData(){
    if(!accountName){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter account name");			
      return false;
    }
    if(!contactName){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter contact name");			
      return false;
    }
    if(!mobile){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter mobile");			
      return false;
    }

		if(accountName){ 

			let axiosHeader = {
        headers: {
          'Content-Type': 'multipart/mixed',
          'device': 'web',
          'registerId': props.userObj.registerId,
          'uid': props.userObj.loginId,
          'fullName': props.userObj.fullName,
          'token': props.userObj.token,
        }
      };

      const data = new FormData();
      if(props.dataObj && props.dataObj.autoId){
        data.append('id', props.dataObj.autoId);
      }
      data.append('accountName', accountName.trim());
      if(category && category!=='noselect'){
        data.append('accountCategory', category);
      }
      data.append('company', company);
      data.append('website', website);
      data.append('gstNumber', gstNumber);
      data.append('panNumber', panNumber);
      data.append('aadhaarNumber', aadhaarNumber);
      data.append('cin', cin);
      data.append('consigneeCode', consigneeCode);
      data.append('products', products);
      data.append('companyType', companyType);
      data.append('registrationYear', registrationYear);
      data.append('turnover', turnover);
      data.append('industry', industry);
      data.append('rank', rank); 
      data.append('creditDays', creditDays);
      data.append('purchasePotential', purchasePotential);
      if(tags && tags.length>0){
        data.append('tags', tags.join(','));
      }else{
        data.append('tags', '');
      }
      
      data.append('contactName', contactName);
      data.append('mobile', mobile);
      data.append('phone', phone);
      data.append('email', email);
      data.append('address', address);
      data.append('city', city);
      data.append('state', state);
      data.append('zipCode', pinCode);
      data.append('country', country);

      if(ownerId && ownerId>0){
        data.append('ownerId', ownerId);
        data.append('ownerAlias', ownerAlias);
      }

      data.append('accessType', accessType);
      data.append('accessWithType', accessWithType);
      data.append('accessWithNames', accessWithNames);
      data.append('accessWithIds', accessWithIds);

      let apiURL='/crm-create-accounts';
      if(props.dataObj!=null && props.dataObj.autoId){
          apiURL='/crm-update-accounts';
      }
      setSaveLoading(true);       
			axios.post(API_URL+apiURL, data, axiosHeader)
			.then((response) => {
        setSaveLoading(false);        
				//console.log("RESPONSE RECEIVED: ", response.data.responseTxt); mobileExists
				if(response.data.responseTxt==="success"){
          setSeverityAlert("success");
          setOpen(false);
					setShowAlert(true);
					setAlertMessage("Account detail has been saved.");
          props.updatedList(response.data.list);	
					return false;

        }else if(response.data.responseTxt==="limitexceeded"){
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Your app records limit exceeded. You must upgrade your package to add more data.");			
					return false;  

        }else if(response.data.responseTxt==="alreadyexistserror"){
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Account name is already created");			
					return false;  

				}else if(response.data.responseTxt==="invalidtoken"){
					navigate('/invalidtoken');

        }else if(response.data.responseTxt==="mobileExists"){
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Mobile number is already exists with another account");			
					return false;  

        }else if(response.data.responseTxt==="emailExists"){
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Email is already exists with another account");			
					return false;  

				}else{
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Account detail could not be saved.");			
					return false;
				}
			})
			.catch((error) => {
				  setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage(""+error);			
					return false;
			})	
		}		
	}

  function selectUser(){
    childRefUser.current.handleClickOpen();
  }
  function userDetail(obj) {
    setOwnerId(obj.autoId);
    setOwnerAlias(obj.fullName);    
  }

  function selectedTags(arr) {
    setTags(arr);
  }

  // const setAutoCompleteDataDetail = (obj,accName) => {
  //   if(obj){
  //     setAccountId(obj.autoId);
  //     setAccountName(obj.title);
  //   }else if(accName && accName.length>0){
  //     setAccountName(accName);
  //     setAccountId("");
  //   }    
  // }
  
  return (
    <>
      <Dialog fullWidth maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}></DialogTitle>
          <DialogContent >
            <Grid item md={12} xs={12} >
                  <div className="btmbdrgry"><h4>New Account</h4></div>

                  <Box mt={2} mb={1} >
                  <Grid container spacing={2}>                          
                      <Grid item md={6} xs={12} >

                              <TextField label="Unique Account Name" onChange={event => setAccountName(event.target.value)} value={accountName} fullWidth variant="outlined" size='small' />

                                <FormControl fullWidth size='small' style={{marginTop:14}} >
                                    <InputLabel id="demo-simple-select-label">Category</InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      value={category}
                                      label="Category"
                                      onChange={event => setCategory(event.target.value)}
                                    >
                                      <MenuItem value={'noselect'}>Select Category</MenuItem>
                                      {categoryList?categoryList.map((myRow,mykey)=>(
                                        <MenuItem key={'ct'+mykey} value={myRow.category}>{myRow.category}</MenuItem>
                                      )):null}
                                    </Select>
                                  </FormControl>

                                  <TextField label="Company" onChange={event => setCompany(event.target.value)} value={company} fullWidth variant="outlined" size='small' style={{marginTop:14}} />

                                  <TextField label="Contact Person Name" onChange={event => setContactName(event.target.value)} value={contactName} fullWidth variant="outlined" size='small' style={{marginTop:14}}  />
                                  <TextField label="Mobile" onChange={event => setMobile(event.target.value)} value={mobile} fullWidth variant="outlined" inputProps={{maxlength:10}} size='small' style={{marginTop:14}} />
                                  <TextField label="Phone" onChange={event => setPhone(event.target.value)} value={phone} fullWidth variant="outlined" size='small' style={{marginTop:14}} />
                                  <TextField label="Email" onChange={event => setEmail(event.target.value)} value={email} fullWidth variant="outlined" size='small' style={{marginTop:14}} />
                                  <TextField label="Address" onChange={event => setAddress(event.target.value)} value={address} fullWidth variant="outlined" size='small' style={{marginTop:14}} />
                                  <TextField label="City" onChange={event => setCity(event.target.value)} value={city} fullWidth variant="outlined" size='small' style={{marginTop:14}} />
                                  <TextField label="State" onChange={event => setState(event.target.value)} value={state} fullWidth variant="outlined" size='small' style={{marginTop:14}} />
                                  <TextField label="Pin Code" onChange={event => setPinCode(event.target.value)} value={pinCode} fullWidth variant="outlined" size='small' style={{marginTop:14}} />
                                  <TextField label="Country" onChange={event => setCountry(event.target.value)} value={country} fullWidth variant="outlined" size='small' style={{marginTop:14}} />

                                  <TextField label="Website" onChange={event => setWebsite(event.target.value)} value={website} fullWidth variant="outlined" size='small' style={{marginTop:14}} />

                                  <div style={{marginTop:14}} >  
                                    <TagsOptions defaultValues={tags} selectedTags={selectedTags} options={[{title:'abc'}]} />
                                  </div>                            

                        
                      </Grid>
                      <Grid item md={6} xs={12} >

                                  <TextField label="Rank" onChange={event => setRank(event.target.value)} value={rank} fullWidth variant="outlined" size='small' />
                                  <TextField label="Products & Services Sell" onChange={event => setProducts(event.target.value)} value={products} fullWidth variant="outlined" size='small' style={{marginTop:14}} />

                                  <TextField label="Purchase Potential" onChange={event => setPurchasePotential(event.target.value)} value={purchasePotential} fullWidth variant="outlined" size='small' style={{marginTop:14}} />
                                  <TextField label="Credit Days" onChange={event => setCreditDays(event.target.value)} value={creditDays} fullWidth variant="outlined" size='small' style={{marginTop:14}} />
                                  <TextField label="GST Number" onChange={event => setGstNumber(event.target.value)} value={gstNumber} fullWidth variant="outlined" size='small' style={{marginTop:14}} />
                                  <TextField label="PAN Number" onChange={event => setPanNumber(event.target.value)} value={panNumber} fullWidth variant="outlined" size='small' style={{marginTop:14}} />
                                  <TextField label="Aadhaar Number" onChange={event => setAadhaarNumber(event.target.value)} value={aadhaarNumber} fullWidth variant="outlined" size='small' style={{marginTop:14}} />
                                  <TextField label="Corporate Identification Number (CIN)" onChange={event => setCin(event.target.value)} value={cin} fullWidth variant="outlined" size='small' style={{marginTop:14}} />
                                  <TextField label="Consignee Code" onChange={event => setConsigneeCode(event.target.value)} value={consigneeCode} fullWidth variant="outlined" size='small' style={{marginTop:14}} />

                                  <FormControl fullWidth size='small' style={{marginTop:14}} >
                                      <InputLabel id="demo-simple-select-label">Company Type</InputLabel>
                                      <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={companyType}
                                        label="Company Type"
                                        onChange={event => setCompanyType(event.target.value)}
                                      >
                                        <MenuItem value={''}>Not Selected</MenuItem>
                                        <MenuItem value={'Sole Proprietorship'}>Sole Proprietorship</MenuItem>
                                        <MenuItem value={'One Person Company'}>One Person Company</MenuItem>
                                        <MenuItem value={'Partnerships Company'}>Partnerships Company</MenuItem>
                                        <MenuItem value={'Private Limited Company'}>Private Limited Company</MenuItem>
                                        <MenuItem value={'Public Limited Company'}>Public Limited Company</MenuItem>
                                      </Select>
                                    </FormControl>

                                  <TextField label="Year of Registeration" onChange={event => setRegistrationYear(event.target.value)} value={registrationYear} fullWidth variant="outlined" size='small' style={{marginTop:14}} />
                                  <TextField label="Sales Turnover" onChange={event => setTurnover(event.target.value)} value={turnover} fullWidth variant="outlined" size='small' style={{marginTop:14}} />
                                  <TextField label="Industry" onChange={event => setIndustry(event.target.value)} value={industry} fullWidth variant="outlined" size='small' style={{marginTop:14}} />

                                  <Grid container spacing={2}>
                                    <Grid item md={8} xs={8} >
                                        <TextField
                                          label="Agent"
                                          onChange={event => setOwnerAlias(event.target.value)}
                                          value={ownerAlias}
                                          fullWidth
                                          size='small'
                                          variant="outlined"                           
                                          InputProps={{                                            
                                            readOnly: true,
                                            endAdornment: (
                                              <InputAdornment position="end">
                                                <SavedSearchIcon style={{cursor:'pointer'}} onClick={()=>{selectUser()}} />
                                              </InputAdornment>
                                            ),
                                            }}

                                            style={{marginTop:14}}
                                      />
                                    </Grid>
                                    <Grid item md={4} xs={4} >
                                      <FormControl fullWidth size='small'style={{marginTop:14}}  >
                                        <InputLabel id="demo-simple-select-label">Visibility</InputLabel>
                                        <Select
                                          labelId="demo-simple-select-label"
                                          id="demo-simple-select"
                                          value={accessType}
                                          label="Visibility"
                                          onChange={event => setAccessType(event.target.value)}
                                        >
                                          <MenuItem value={1} >Public</MenuItem>
                                          <MenuItem value={2} >Private</MenuItem>
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                  </Grid>

                      </Grid>                      
                    </Grid>    
                  </Box>        

                  <Box mt={1} mb={1} >
						        <Grid container spacing={2}>
                          <Grid item md={12} xs={12} >
                            <Button onClick={() => {handleClose()}} style={{marginRight:12}} size="small" variant="outlined" >Cancel</Button>
                            {saveLoading?
                            <LoadingButton loading={saveLoading} loadingPosition="start" startIcon={<SaveIcon />} style={{marginRight:20, backgroundColor:'#ea1072',color:'#FFF'}}  size="small" variant="contained" >Saving...</LoadingButton>
                            :<Button onClick={() => {saveData()}} size="small" variant="contained" style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} >Save</Button>
                            }
                            
                          </Grid>
                    </Grid>
                  </Box>              

            </Grid>
          </DialogContent>
      </Dialog>
      
        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

        <AgentSelect userObj={props.userObj} fetchDetail={userDetail} fetch={true} ref={childRefUser} />

    </>
  );

});

export default CustomizedDialogs;